export const brand = {
  name: 'POSTMAN',
  cabinetUrl: 'https://pman.work/customer_users/sign_in',
  trackingApiUrl: process.env.NODE_ENV === 'development'
    ? '/api/public/v1/global_tracking'
    : 'https://pman.work/api/public/v1/global_tracking',
  contact: {
    phone: '+7 777 007 21 81',
    phoneHref: 'tel:+77770072181',
    email: 'postman_kz@mail.ru',
    address: 'РК, индекс A20F2X1 (050034), г. Алматы, Жетысуский район, ул. Ниязбекова, дом 33',
    mapUrl: 'https://yandex.kz/maps/?text=%D0%90%D0%BB%D0%BC%D0%B0%D1%82%D1%8B%2C%20%D1%83%D0%BB%D0%B8%D1%86%D0%B0%20%D0%9D%D0%B8%D1%8F%D0%B7%D0%B1%D0%B5%D0%BA%D0%BE%D0%B2%D0%B0%2C%2033',
  },
  legal: {
    company: 'ТОО «POSTMAN»',
    rnn: '600 700 597 765',
    bin: '0712 4001 6167',
    bic: 'HSBKKZKX',
    bank: 'АО «Народный Банк Казахстана»',
    iban: 'KZ036017131000013801',
    vatCertificate: 'Серия 60001 №0047777 от 24.09.2012 г.',
    address: 'РК, индекс A20F2X1 (050034), г. Алматы, Жетысуский район, ул. Ниязбекова, дом 33',
    director: 'Алимов Бакыт Хасанович',
  },
};

const apiLocales = {
  en: 'en',
  kk: 'kz',
  ru: 'ru',
};

export function buildTrackingApiUrl(code, language) {
  const locale = apiLocales[language] || 'ru';
  return `${brand.trackingApiUrl}/${encodeURIComponent(code)}?locale=${locale}`;
}
